var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isSingleSchool)?_c('SingleSchool',{attrs:{"asuulga":_vm.asuulga}}):_c('AllSchool',{attrs:{"asuulga":_vm.asuulga}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }